import { getSite, getSiteConfiguration } from "@/src/utils/configUtils";

// TODO: 这里可以直接改成site
export function openChat(host: string) {
    if (getSite(host) !== "fm") {
        // 检查是否为“快牛”站点配置
        if (getSiteConfiguration('isQuickCow', host)) {
            // 为了避免 TypeScript 报错，先判断 parent 是否有 quickChatApi 属性
            // 可以通过类型断言或可选链操作符 ?. 来安全访问
            if ((parent as any).quickChatApi && typeof (parent as any).quickChatApi.chat === "function") {
                (parent as any).quickChatApi.chat();
            }
        } else {
            // 检查 parent 是否有 LC_API 属性，并且 open_chat_window 是函数
            if ((parent as any).LC_API && typeof (parent as any).LC_API.open_chat_window === "function") {
                parent.LC_API.open_chat_window({ source: 'minimized' });
            }
        }
    } else {
        if (
            window.zE &&
            window.zE.activate &&
            typeof window.zE.activate === "function"
        ) {
            alert('activate');
            window.zE.activate();
        }
    }
}
